<template>
  <div
    class="relative w-full pb-5 flex flex-col justify-between rounded-3xl"
    :class="[background, height]">
    <BaseImage
      v-if="src"
      :src="src"
      height="100%"
      width="100%"
      fit="contain"
      alt="welcome_image"
      class="absolute top-0 left-0"
      density="compact"/>
    <div
      class="relative gap-4 px-12 lg:px-24 z-10 flex flex-col justify-center items-center h-full">
      <div>
        <div
          class="inline font-anomaliaBold text-md max-h-md:text-xl max-h-lg:text-2xl"
          :class="textColor">
          {{ prefix }}
        </div>
        <div
          class="inline-block rotate-[354deg] font-anomaliaBold text-[#F6652A] text-xl max-h-md:text-2xl max-h-lg:text-5xl px-2">
          {{ computedFinalDay?.count }}
        </div>
        <div
          class="inline font-anomaliaBold text-md max-h-md:text-xl max-h-lg:text-2xl"
          :class="textColor">
          {{ suffix }}
        </div>
      </div>
      <div
        v-if="footerText"
        class="font-anomaliaBold text-md max-h-md:text-xl max-h-lg:text-2xl c"
        :class="textColor">
        {{ footerText }}
      </div>
      <div
        v-if="computedFinalDay?.text"
        class="z-10 mt-10 whitespace-pre-line text-white text-lg max-h-lg:text-2xl text-center font-anomaliabold">
        {{ computedFinalDay?.text }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computedFinalDay } from '@/apps/slideshowGame/useCalculation';
import BaseImage from '@/components/BaseImage/BaseImage.vue';

interface IProps {
  src?: string;
  prefix?: string;
  suffix?: string;
  footerText?: string;
  textColor?: string;
  background?: string;
  height?: string;
}

withDefaults(defineProps<IProps>(), {
  prefix: '',
  suffix: '',
  src: '',
  footerText: '',
  textColor: 'text-black',
  background: 'white',
  height: 'h-screen',
});
</script>
